import React from 'react'
import './contact.css'
import {MdOutlineEmail} from 'react-icons/md'

const Contact = () => {
  return (
    <section id='contact'>
      <h5>Get in Touch</h5>
      <h2>Contact Me</h2>

    <div className="container contact__container">
      <div className="contact__options">
        <article className="contact__option">
          <MdOutlineEmail className="contact_option-icon"/>
          <h4>Email</h4>
          <h5>alimazharsultan@gmail.com</h5>
          <a href="mailto:alimazharsultan@gmail.com" target="_blank">Send a Message</a>
        </article>
        <article className="contact__option">
          <MdOutlineEmail className="contact_option-icon"/>
          <h4>Messenger</h4>
          <h5>alimazharsultan</h5>
          <a href="https://m.me/CHalimazharsultan" target="_blank">Send a Message</a>
        </article>
        <article className="contact__option">
          <MdOutlineEmail className="contact_option-icon"/>
          <h4>Whatsapp</h4>
          <h5>+92-335-5433725</h5>
          <a href="https://api.whatsapp.com/send?phone=+923355433725" target="_blank">Send a Message</a>
        </article>
      </div>
      <form action="">
        <input type="text" name="name" placeholder="Your Full Name" required />
        <input type="email" name="email" placeholder="Your email" required />
        <textarea name="message" rows="7" ></textarea>
        <button type="submit" className='btn btn-primary'>Send Message</button>
      </form>
    </div>

    </section>
  )
}

export default Contact